import type { ActionAvailability } from "@amber/contracts";

export function find(actions: readonly ActionAvailability[], name: string): ActionAvailability | undefined {
  return actions.find((a) => a.action === name);
}

export function reasonOf(action: ActionAvailability | undefined): string | null {
  return action && !action.enabled ? action.reason : null;
}
